<template>
  <tr>
    <td>{{ medicine.name }}</td>
    <td>{{ applicationRoute.name }}</td>
    <td>{{ applicationSite.name }}</td>
    <td>{{ numberOfApplications }}</td>
    <td>{{ interval }}</td>
    <td>{{ buildingInformation.dilation ? "Sim" : "Não" }}</td>
    <td>{{ buildingInformation.refract ? "Sim" : "Não" }}</td>
    <td>
      <authorization
        permissionKey="configuration_facilitator_medicine"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(templateItem)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_facilitator_medicine"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(templateItem)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </td>
  </tr>
</template>

<script>
  export default {
    name: "TemplateItemTableRow",
    props: {
      templateItem: Object,
      editItem: Function,
      deleteItem: Function,
      medicines: Array,
    },
    computed: {
      buildingInformation() {
        return this.templateItem.buildingInformation;
      },
      medicine() {
        let medicine = this.lodash.find(this.medicines, {
          id: this.buildingInformation.medicine_id,
        });

        if (!medicine) {
          return {};
        }

        return medicine;
      },
      applicationRoute() {
        let applicationRoute = this.lodash.find(this.medicine.applicationRoutes, {
          id: this.buildingInformation.medicine_application_route_id,
        });

        if (!applicationRoute) {
          return {};
        }

        return applicationRoute;
      },
      applicationSite() {
        let applicationSite = this.lodash.find(this.applicationRoute.applicationSites, {
          id: this.buildingInformation.medicine_application_site_id,
        });

        if (!applicationSite) {
          return {};
        }

        return applicationSite;
      },
      interval() {
        let interval = this.buildingInformation.interval;
        if (interval > 60) {
          interval = interval / 60;

          if (interval === 1) return `${interval} hora`;

          return `${interval} horas`;
        }

        return `${interval} minutos`;
      },
      numberOfApplications() {
        let numberOfApplications = this.buildingInformation.number_of_applications;

        if (numberOfApplications === 1) return `${numberOfApplications} vez`;

        return `${numberOfApplications} vezes`;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
